import { createContext, ReactNode, useContext, useEffect, useState } from 'react'

interface UserInteractivityProvider {
    registerFirstInteraction?: () => void
    registerLastInteraction?: () => void
}

const FlowContext = createContext<UserInteractivityProvider>({})

/** @deprecated */
export const useUserInteractivity = (): UserInteractivityProvider => {
    return useContext(FlowContext)
}

interface UserInteractivityProps {
    children: ReactNode
}

/**
 * Keeps track whether a user has interaction with the application,
 * starting with the check, and ending with approval of the contracts.
 */
export const UserInteractivityProvider = ({ children }: UserInteractivityProps): JSX.Element => {
    const [hasInteraction, setHasInteraction] = useState<boolean>(false)

    const registerFirstInteraction = (): void => {
        if (!hasInteraction) setHasInteraction(true)
    }

    const registerLastInteraction = (): void => {
        if (hasInteraction) setHasInteraction(false)
    }

    useEffect(() => {
        if (!hasInteraction) return

        window.addEventListener('beforeunload', alertUser, { capture: true })
        return () => {
            window.addEventListener('beforeunload', alertUser, { capture: true })
        }
    }, [hasInteraction])

    /** See example on https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event */
    const alertUser = (event: BeforeUnloadEvent): string => {
        event.preventDefault()
        return (event.returnValue = '')
    }

    const providerValue: UserInteractivityProvider = {
        registerFirstInteraction,
        registerLastInteraction,
    }

    return <FlowContext.Provider value={providerValue}>{children}</FlowContext.Provider>
}
